import { initializeFirebaseClient, type FirebaseClientConfig } from '@skiphr/firebase-client'

const required = (name: keyof ImportMetaEnv, fallback = ''): string =>
  import.meta.env[name] ?? fallback

const projectId = required('VITE_FIREBASE_PROJECT_ID', 'skiphr-development')

/**
 * Hosts that serve the Firebase auth handler themselves. Signing in on the same host lets Google
 * sign-in use a full-page redirect, which avoids cross-origin popups and third-party cookies.
 */
const SAME_ORIGIN_AUTH_HOSTS = ['app.skiphr.ai']
export const sameOriginAuth = SAME_ORIGIN_AUTH_HOSTS.includes(window.location.hostname)

const baseConfig: FirebaseClientConfig = {
  apiKey: required('VITE_FIREBASE_API_KEY', 'emulator-api-key'),
  authDomain: sameOriginAuth ? window.location.hostname : required('VITE_FIREBASE_AUTH_DOMAIN', 'localhost'),
  projectId,
  storageBucket: required('VITE_FIREBASE_STORAGE_BUCKET', 'skiphr-development.appspot.com'),
  messagingSenderId: required('VITE_FIREBASE_MESSAGING_SENDER_ID', '000000000000'),
  appId: required('VITE_FIREBASE_APP_ID', '1:000000000000:web:development'),
  useEmulators: import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true',
}

const appCheckSiteKey = import.meta.env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY

export const firebaseClient = initializeFirebaseClient(
  appCheckSiteKey ? { ...baseConfig, appCheckSiteKey } : baseConfig,
)
